import React from 'react';
import clsx from 'clsx';
import { ls } from '../../../locale';
import { Checkbox } from '../../../comps/checkbox';
import { numberFormatter } from '../../../helpers';

type PriceBoxProps = {
  service: any;
  selected: boolean;
  included: boolean;
  currencyCode: string;
  onClick: (service: any) => void;
};

export function PriceBox({service, selected, included, currencyCode, onClick}: PriceBoxProps) {

  const handleClick = () => {
    if(included) return;
    
    if(typeof onClick === 'function') {
      onClick(service);
    }
  }

  const rCommon = ls.t('Common');
  const amount = numberFormatter.formatCurrency(service.amount)

  return (
    <div className={clsx('tw-flex tw-flex-row md:tw-flex-col tw-mb-[1px] md:tw-mb-0 tw-items-center tw-gap-4 md:tw-gap-0 md:tw-min-w-40 tw-p-4',
      'tw-cursor-pointer',
      'hover:tw-shadow-inset-blue',
      'tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 md:tw-border-t-0',
      selected && !included ? 'tw-shadow-inset-blue' : 'tw-border-0 tw-border-x tw-border-solid tw-border-gray-200',
    )} onClick={handleClick}>
      <div className='tw-block tw-grow md:tw-hidden tw-text-lg'>{service.description}</div>
      { !included && <div className='tw-text-lg md:tw-text-sm tw-font-bold sa-text-green'>{currencyCode} {amount}</div>}
      <div className='tw-hidden md:tw-block tw-text-[10px] tw-mb-3'>{service.description}</div>
      { included ? <span className='included'>{rCommon.Included}</span> : <Checkbox checked={selected} /> }
    </div>
  )
}